import { render } from "./BattlesGame.vue?vue&type=template&id=356feba8&scoped=true"
import script from "./BattlesGame.vue?vue&type=script&lang=js"
export * from "./BattlesGame.vue?vue&type=script&lang=js"

import "./BattlesGame.vue?vue&type=style&index=0&id=356feba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356feba8"]])

export default __exports__